import { connect } from 'react-redux';

import Standings from './Standings';
import { fetchStandings } from './state/standingsActions';

const mapStateToProps = (state, ownProps) => {
  return {
    standingsData: state.standingsData,
    client: state.client,
    isLoading: state.isLoading,
    sportId: ownProps.sportId,
    productId: ownProps.productId,
    isAuthorized: state.isAuthorized
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchStandings: (sporId, clientId, productId) => dispatch(fetchStandings(sporId, clientId, productId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Standings);


// WEBPACK FOOTER //
// ./src/screens/standingsScreen/StandingsContainer.jsx